import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class EntityRefOfInt64
*  Информация о группе атрибутов. <br><br>Если null, значит группа для атрибутов Web.Api.Showcases.Controllers.Products.Models.ProductAttributesGroupDto.Attributes отсутствует<br>
*/
export class EntityRefOfInt64 extends ActiveModel {

  /**
  * id
  * Идентификатор связанных данных<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * displayName
  * Название связанных данных<br>
  */
  @ActiveField()
  displayName?: null | string
}
